import React, { memo } from 'react';
import {
	Route,
	Switch,
	useRouteMatch
} from 'react-router-dom';

import { log } from '../../../../services/utils';

import { useAuthState } from '../../../../contexts/AuthContext';
import { Provider as CalendarProvider } from '../../../../contexts/CalendarContext';

import Calendar from './Calendar';
import EventDetails from './EventDetails';

const Events = () => {
	let { path } = useRouteMatch();

	const { user: { permissions } } = useAuthState();

	return (
		<CalendarProvider>
			{ log( 'calendar' ) }
			<Switch>
				{ permissions.addCalendarEvents.isAvailable && permissions.addCalendarEvents.canExecute
					|| permissions.viewCalendarEvents.isAvailable && permissions.viewCalendarEvents.canExecute
					|| permissions.editCalendarEvents.isAvailable && permissions.editCalendarEvents.canExecute
					? <Route
						path={ `${ path }/:id` }
						component={ EventDetails }
					/>
					: null
				}
				<Route
					exact
					path={ path }
					component={ Calendar }
				/>
			</Switch>
		</CalendarProvider>
	);
};

export default memo( Events );
